import type React from "react";
import { cn } from "@/lib/utils";

interface CollapsibleToolPanelProps {
  isExpanded: boolean;
  collapsedHeight: string;
  children: React.ReactNode;
  className?: string;
}

export const CollapsibleToolPanel: React.FC<CollapsibleToolPanelProps> = ({
  isExpanded,
  collapsedHeight,
  children,
  className,
}) => (
  <div
    className={cn(
      "relative min-h-0",
      isExpanded ? "flex-1" : "overflow-visible",
      className,
    )}
    style={isExpanded ? undefined : { height: collapsedHeight }}
  >
    {children}
  </div>
);
